import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Staffbusrentalforpunecompanies() {



const cardData =
{
  keyword: 'Staff Bus Rental for Pune Companies',
  heading: 'Sanavi Travels: Staff Bus Rental for Pune Companies',
  headingDescription: 'Sanavi Travels provides dependable and cost-effective Staff Bus Rental for Pune Companies, helping organizations ensure safe, punctual, and organized daily transportation for employees across Pune and nearby industrial, IT, and corporate hubs.',

  top: 'Employee Transportation & Corporate Travel Experiences with Sanavi Travels',

  topPlaces: [
    {
      title: 'Daily Office Commute for Pune Companies',
      description: 'Staff bus rental plays a critical role in managing daily office commute for companies operating in Pune. With increasing traffic congestion and rising fuel costs, organizations prefer dedicated staff buses to ensure employees reach the workplace on time and return home safely. A staff bus creates a disciplined travel routine, reduces late arrivals, and improves overall workforce productivity. Employees can relax during the journey, mentally prepare for the workday, and avoid the stress of driving through heavy traffic. For employers, staff buses simplify attendance management and promote punctuality across departments.'
    },
    {
      title: 'IT Parks & Corporate Hubs Transportation',
      description: 'Pune is home to major IT parks and business hubs such as Hinjewadi, Magarpatta, Kharadi, Pimpri Chinchwad, Talawade, and Baner. Staff bus rental ensures smooth employee transportation to these high-density work zones where parking and peak-hour traffic are constant challenges. Organized bus transport reduces road congestion, lowers parking demand, and ensures a smooth flow of employees during shift changes. Companies benefit from reliable routing and optimized pickup schedules that align with office timings.'
    },
    {
      title: 'Industrial Areas & MIDC Employee Transport',
      description: 'Manufacturing units and factories located in MIDC areas around Pune rely heavily on staff buses to transport workers across multiple shifts. Staff bus rental supports early morning, late night, and rotational shifts while ensuring worker safety and punctuality. Reliable staff transport improves attendance consistency and helps industries maintain uninterrupted operations. Employees from distant residential areas gain access to stable and affordable daily commute options.'
    },
    {
      title: 'Shift-Based Employee Pickup & Drop',
      description: 'Many companies operate in rotational or night shifts, making public transport unreliable for employees. Staff bus services offer structured pickup and drop facilities with trained drivers who follow strict schedules. This enhances employee safety, especially for women employees and late-night shifts. Shift-based routing ensures optimized travel time and predictable daily commute.'
    },
    {
      title: 'Corporate Team Outings & Training Programs',
      description: 'Beyond daily commute, staff buses are widely used for corporate training programs, workshops, offsite meetings, and team outings. Renting a staff bus allows companies to move employees together, maintain schedules, and encourage team bonding. Group travel ensures punctual arrival at training venues and smooth coordination throughout the event.'
    },
    {
      title: 'Employee Engagement & Satisfaction',
      description: 'Providing staff transportation reflects a company’s commitment to employee well-being. Comfortable and reliable bus services reduce daily commute stress, leading to higher job satisfaction and improved morale. Employees appreciate employer-supported travel, especially in cities like Pune with growing commute distances.'
    },
    {
      title: 'Cost Control & Transport Efficiency',
      description: 'Staff bus rental helps companies control transportation expenses by consolidating employee travel into shared vehicles. Compared to individual reimbursements or cab usage, staff buses offer predictable monthly costs and better budget management. This efficiency supports long-term operational planning.'
    },
    {
      title: 'Eco-Friendly Corporate Travel',
      description: 'Using staff buses instead of multiple individual vehicles significantly reduces fuel consumption and carbon emissions. Companies adopting shared employee transport contribute to environmental sustainability while aligning with green mobility initiatives and corporate social responsibility goals.'
    },
    {
      title: 'Safe & Disciplined Group Movement',
      description: 'Staff buses promote disciplined travel with fixed routes, designated pickup points, and monitored schedules. This structured approach minimizes travel-related risks, enhances safety, and ensures accountability for both employers and transport providers.'
    },
    {
      title: 'Scalable Transport for Growing Companies',
      description: 'As organizations expand, staff bus rental services can be scaled easily by adding more buses or routes. This flexibility allows companies to adapt transportation capacity according to workforce growth without logistical challenges.'
    }
  ],

  services: [
    {
      name: 'Staff Bus Rental for Pune Companies',
      description: 'Sanavi Travels offers dedicated staff bus rental services for Pune companies, supporting daily employee commute, shift-based transport, and corporate travel needs. Our buses are maintained to high safety standards and operated by professional drivers, ensuring reliable and stress-free employee transportation. Companies benefit from punctual service, optimized routing, and consistent travel management that supports workforce efficiency and attendance discipline.'
    },
    {
      name: 'AC Staff Bus for Pune Companies',
      description: 'AC staff buses provide a comfortable and climate-controlled commute for employees, especially during long-distance travel and summer months. Air-conditioned buses enhance employee comfort, reduce fatigue, and improve daily travel experience, making them ideal for IT companies and corporate offices.'
    },
    {
      name: 'Non AC Staff Bus Pune Companies',
      description: 'Non AC staff buses offer a cost-effective solution for companies seeking reliable employee transport while managing budgets efficiently. These buses maintain safety and seating comfort, making them suitable for short to medium-distance daily routes.'
    },
    {
      name: '32 Seater Staff Bus Pune',
      description: '32 seater staff buses are ideal for medium-sized employee groups, balancing seating capacity and operational efficiency. They are commonly used for office commute, factory shifts, and departmental transport.'
    },
    {
      name: '35 Seater Staff Bus Hire Pune',
      description: '35 seater staff buses support larger employee groups and high-density routes. Traveling in a single vehicle improves coordination, reduces multiple pickups, and ensures timely arrivals.'
    },
    {
      name: 'Mini Bus on Rent for Staff Pune',
      description: 'Mini staff buses are suitable for small teams, startups, and branch offices. They offer flexibility in routing and are ideal for areas with limited road access or compact employee groups.'
    },
    {
      name: 'Luxury Staff Bus Hire Pune',
      description: 'Luxury staff buses provide premium seating, smooth suspension, and enhanced ride quality for senior staff, executives, and premium corporate travel requirements.'
    },
    {
      name: 'Staff Bus for Office Commute Pune',
      description: 'Office commute staff bus services ensure employees reach the workplace on time every day. Fixed routes, reliable schedules, and safe driving contribute to punctuality and reduced absenteeism.'
    },
    {
      name: 'Staff Bus for Corporate Travel Pune',
      description: 'Corporate travel staff buses support meetings, training programs, conferences, and inter-office movement, ensuring professional and organized transport for employees.'
    },
    {
      name: 'Affordable Staff Bus Rental Pune',
      description: 'Affordable staff bus rental plans help companies manage employee transportation costs efficiently while maintaining service quality and safety standards.'
    },
    {
      name: 'Best Staff Bus Service Pune',
      description: 'Sanavi Travels is recognized as a trusted provider of staff bus services in Pune, known for reliability, safety, and customer-focused corporate transport solutions.'
    },
    {
      name: 'Staff Bus with Driver Pune',
      description: 'All staff bus rentals include experienced drivers trained in corporate travel discipline, route familiarity, and safe driving practices.'
    },
    {
      name: 'Staff Bus for Employee Pickup Pune',
      description: 'Employee pickup services ensure safe and timely transportation from residential areas to office locations, supporting structured daily commute.'
    },
    {
      name: 'Staff Bus for Team Outing Pune',
      description: 'Team outings and engagement activities are managed smoothly with staff bus hire, allowing employees to travel together and enjoy group experiences.'
    },
    {
      name: 'Staff Bus for Company Events Pune',
      description: 'Company events, seminars, and celebrations require organized group transport. Staff buses ensure coordinated arrivals and hassle-free movement of employees.'
    }
  ],

  tableData: [
    ['Staff Bus Rental Pune', 'AC Staff Bus'],
    ['Non AC Staff Bus', 'Luxury Staff Bus'],
    ['32 Seater Bus', '35 Seater Bus'],
    ['Daily Office Commute', 'Shift Transport'],
    ['Corporate Events', 'Team Outings']
  ],

  whychoose: [
    { WhyChooseheading: 'Corporate Travel Expertise', WhyChoosedescription: 'Specialized in employee transportation services.' },
    { WhyChooseheading: 'Punctual & Reliable', WhyChoosedescription: 'On-time pickups and drops every day.' },
    { WhyChooseheading: 'Safe Employee Transport', WhyChoosedescription: 'Experienced drivers and maintained buses.' },
    { WhyChooseheading: 'Cost-Effective Solutions', WhyChoosedescription: 'Affordable long-term rental plans.' },
    { WhyChooseheading: 'Flexible Fleet Options', WhyChoosedescription: 'Mini, standard, and luxury buses available.' },
    { WhyChooseheading: 'Scalable Services', WhyChoosedescription: 'Easy expansion with company growth.' },
    { WhyChooseheading: 'Eco-Friendly Travel', WhyChoosedescription: 'Reduced carbon footprint through shared transport.' },
    { WhyChooseheading: 'Trusted Corporate Partner', WhyChoosedescription: 'Sanavi Travels is known for dependable service.' }
  ]
};

const faqData = [
  { question: 'Do you provide staff bus rental for Pune companies?', answer: 'Yes, Sanavi Travels offers staff bus rental services for companies in Pune.' },
  { question: 'Are AC and Non AC staff buses available?', answer: 'Yes, both AC and Non AC options are available.' },
  { question: 'Is this service suitable for IT companies?', answer: 'Yes, it is ideal for IT parks and corporate hubs.' },
  { question: 'Do buses support shift-based transport?', answer: 'Yes, shift-based employee transport is available.' },
  { question: 'Are drivers included in the rental?', answer: 'Yes, all staff bus rentals include professional drivers.' },
  { question: 'Can routes be customized?', answer: 'Yes, pickup and drop routes can be customized.' },
  { question: 'Is this cost-effective for companies?', answer: 'Yes, staff bus rental helps reduce transportation costs.' },
  { question: 'Are buses maintained regularly?', answer: 'Yes, all buses are serviced and safety-checked.' },
  { question: 'Do you support corporate events and outings?', answer: 'Yes, staff buses are available for corporate events and team outings.' },
  { question: 'How can we book a staff bus in Pune?', answer: 'You can book through our website or customer support team.' }
];

const testimonials = [
  {
    id: 1,
    name: 'HR Manager, IT Company Pune',
    feedback: 'Sanavi Travels has made our daily employee commute smooth and punctual. Highly reliable staff bus service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Operations Head, Manufacturing Unit',
    feedback: 'Excellent staff transportation solution for our factory shifts. Safe drivers and well-maintained buses.',
    rating: 5
  }
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Staff Bus Rental for Pune Companies - Sanavi Travels",
  "description": "Sanavi Travels offers staff bus rentals for Pune companies, including AC and Non-AC options, 32-seater and 35-seater buses, mini buses, and luxury buses. Ideal for office commute, corporate travel, employee pickup, team outings, and company events with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Call : +91 7387507373 | Staff Bus Rental for Pune Companies | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book staff buses for Pune companies with Sanavi Travels. AC & Non-AC 32-seater, 35-seater, mini, and luxury buses for office commute, corporate travel, employee pickup, team outings, and company events with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/291.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Staffbusrentalforpunecompanies;